import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import padding from '../../tokens/layout/padding'

export const Container = styled.footer`
  background: ${colors.neutralColorHighMedium};
  width: 100%;
  box-sizing: border-box;
  z-index: 500;

  display: flex;
  justify-content: space-between;
  padding: ${padding.spacingInsetSm} ${padding.spacingInsetLg};

  &.light {
    background: ${colors.neutralColorHighPure};
    border-width: 0.1rem 0;
    border-style: solid;
    border-color: ${colors.neutralColorLowLight};
  }
`

export const Text = styled.p`
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: ${colors.neutralColorLowMedium};
  margin: 0;
`
export const TextVersion = Text
